import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import  { BrowserRouter as Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';


ReactDOM.render(<Route><App /></Route>, document.getElementById('root'));


